import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { Code } from 'dcme-style/affordance';
import { Text } from 'dcme-style/affordance';
import { Box } from 'dcme-style/layout';
import { Flex } from 'dcme-style/layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`An immutable, functional data collection library for plain old Javascript.`}</p>
    <p>{`It combines my favourite parts of `}<a parentName="p" {...{
        "href": "https://facebook.github.io/immutable-js/",
        "target": "_blank",
        "rel": ["nofollow", "noopener", "noreferrer"]
      }}>{`immutable.js`}<span parentName="a">{``}</span></a>{`, `}<a parentName="p" {...{
        "href": "https://github.com/lodash/lodash/wiki/FP-Guide",
        "target": "_blank",
        "rel": ["nofollow", "noopener", "noreferrer"]
      }}>{`lodash/fp`}<span parentName="a">{``}</span></a>{` and `}<a parentName="p" {...{
        "href": "https://ramdajs.com/",
        "target": "_blank",
        "rel": ["nofollow", "noopener", "noreferrer"]
      }}>{`ramdajs`}<span parentName="a">{``}</span></a>{` together.`}</p>
    <p>{`Unmutable follows `}<a parentName="p" {...{
        "href": "https://facebook.github.io/immutable-js/",
        "target": "_blank",
        "rel": ["nofollow", "noopener", "noreferrer"]
      }}>{`immutable.js`}<span parentName="a">{``}</span></a>{`'s API almost exactly, and but exports each method individually as a `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Tacit_programming",
        "target": "_blank",
        "rel": ["nofollow", "noopener", "noreferrer"]
      }}>{`point-free function`}<span parentName="a">{``}</span></a>{`, in the same way as `}<a parentName="p" {...{
        "href": "https://github.com/lodash/lodash/wiki/FP-Guide",
        "target": "_blank",
        "rel": ["nofollow", "noopener", "noreferrer"]
      }}>{`lodash/fp`}<span parentName="a">{``}</span></a>{` does. These functions are all immutable, and can be composed together easily.`}</p>
    <p>{`Unmutable also works seamlessly on plain Javascript objects and arrays, Immutable.js Maps, Lists and Records.`}</p>
    <h2 {...{
      "id": "installation"
    }}>{`Installation`}</h2>
    <Flex display={['block', 'flex']} mdxType="Flex">
    <Box mdxType="Box">
        <Text textStyle="code" mdxType="Text">npm install unmutable --save</Text>
    </Box>
    <Box mx={[0, 3]} my={[1, 0]} mdxType="Box">or</Box>
    <Box mdxType="Box">
        <Text textStyle="code" mdxType="Text">yarn add unmutable</Text>
    </Box>
    </Flex>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      